module.exports = __webpack_public_path__ + "static/images/sidebar/expand.svg";